import {Component} from "@angular/core";

@Component({
    selector: "fui-fields",
    styleUrls: ["./fields.component.scss"],
    templateUrl: "./fields.component.html"
})
export class FUIFieldsComponent {
}
